import { render } from "./Paginate.vue?vue&type=template&id=96d9f4ca&ts=true"
import script from "./Paginate.vue?vue&type=script&lang=ts"
export * from "./Paginate.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__